import {createSelector} from 'reselect';

import {selectAllUserThreadsByTeamId} from './select_all_user_threads_by_team_id';

export const selectLatestThreadInTeam = createSelector(selectAllUserThreadsByTeamId, (threads) => threads[0]);
